export enum EMenuKeys {
  BASIC_DATA = 'basic-data',
  DATASHEET = 'datasheet',
  TAX_DATA = 'tax-data',
  SHIPPING_DETAILS = 'shipping-details',
  PUBLICATION = 'publication',
}

export const PRODUCT_STUBSTEP_KEYS = {
  PRODUCT_BASIC_DATA: `${EMenuKeys.BASIC_DATA}-1`,
  PRODUCT_CHARACTERISTICS: `${EMenuKeys.BASIC_DATA}-2`,
  REGULATORY_INFO: `${EMenuKeys.BASIC_DATA}-3`,
  ANATEL_CERTIFICATION: `${EMenuKeys.BASIC_DATA}-4`,
  FIRST_VARIATION_TYPE: `${EMenuKeys.BASIC_DATA}-5`,
  FIRST_VARIATION_VALUE: `${EMenuKeys.BASIC_DATA}-6`,
  SECOND_VARIATION_TYPE: `${EMenuKeys.BASIC_DATA}-7`,
  SECOND_VARIATION_VALUE: `${EMenuKeys.BASIC_DATA}-8`,
  THIRD_VARIATION_TYPE: `${EMenuKeys.BASIC_DATA}-9`,
  THIRD_VARIATION_VALUE: `${EMenuKeys.BASIC_DATA}-10`,
  PRODUCT_VARIATION_DETAILS: `${EMenuKeys.BASIC_DATA}-11`,
}

export const breadcrumbList = ['Modas', 'Roupas', 'Camisetas']
